import { useState, useEffect } from "react";
import ScoutingReportManager from "../../../managers/ScoutingReportsManager";
import { toDivisionApi } from "../../../config/constants";
import { SPLITS_KINDS } from "../components/splits-field-config";
import { fetchSplitsLeaderboard } from "../services/splits-report-service";

export function useSplitsReportData(reportId, kind) {
  const [report, setReport] = useState(null);
  const [allRows, setAllRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!reportId || !SPLITS_KINDS[kind]) return;

    const load = async () => {
      try {
        setLoading(true);
        const reportData = await ScoutingReportManager.getReportById(reportId);
        setReport(reportData);
        if (!reportData) return;

        const rosterKey = SPLITS_KINDS[kind].rosterKey;
        const players = reportData[rosterKey] || [];
        const playerIds = [
          ...new Set(
            players
              .map((p) => p.id ?? p.playerId)
              .filter((x) => x != null && String(x).trim() !== "")
              .map((id) => String(id))
          ),
        ];
        if (!playerIds.length) {
          setAllRows([]);
          setFilteredRows([]);
          return;
        }

        const division = toDivisionApi(reportData.division);
        const year = reportData.year;
        const path = SPLITS_KINDS[kind].leaderboardPath;

        const data = await fetchSplitsLeaderboard(path, division, year);

        const rows = Array.isArray(data) ? data : [];
        setAllRows(rows);
        setFilteredRows(
          rows.filter((r) => r.player_id != null && playerIds.includes(String(r.player_id)))
        );
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [reportId, kind]);

  return { report, allRows, filteredRows, loading };
}
